import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogProductsService } from 'app/core/services/catalog-products.service';

@Component({
  selector: 'itpx-consumption-redirect',
  templateUrl: './consumption-redirect.component.html',
  styleUrls: ['./consumption-redirect.component.css']
})
export class ConsumptionRedirectComponent extends LoadingPage implements OnInit {

  constructor(private route: ActivatedRoute, private service: CatalogProductsService, private router: Router) {
    super();
  }

  ngOnInit() {
    this.loading();
    const sku = this.route.snapshot.paramMap.get('sku');
    this.service.getCatalogProductAssignment(sku).neverError().bindToLifecycle(this).subscribe(res => this.router.navigate(['app', 'course', res.data.id]))

  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/consumption-redirect/consumption-redirect.component.ts